<template>
  <div
    v-if="showUpdateNotice"
    class="fixed inset-x-0 top-[calc(0.5rem+env(safe-area-inset-top,0px))] z-[55] mx-auto flex w-[calc(100%-1.5rem)] max-w-[480px] flex-wrap items-center gap-x-3 gap-y-2 rounded-lg border border-lightGray30 bg-white px-4 py-3 text-left text-[13px] text-textPrimary shadow-lg md:text-[14px]"
    role="status"
    aria-live="polite"
    data-testid="app-update-notice"
  >
    <svg
      class="h-5 w-5 shrink-0 text-primary"
      viewBox="0 0 24 24"
      fill="currentColor"
      aria-hidden="true"
    >
      <path :d="mdiUpdate" />
    </svg>
    <!-- No celular o texto ocupa a 1ª linha inteira e os botões descem para a 2ª. -->
    <span class="min-w-0 flex-1 max-md:basis-[calc(100%-2rem)]"
      >Saiu uma nova versão do Minha Escala.</span
    >
    <div class="ml-auto flex items-center gap-2">
      <button
        type="button"
        class="rounded px-3 py-1.5 text-[13px] font-medium text-primary hover:bg-primary5"
        data-testid="app-update-notice-dismiss"
        @click="dismiss"
      >
        Depois
      </button>
      <button
        type="button"
        class="rounded bg-primary20 px-3 py-1.5 text-[13px] font-medium text-white hover:bg-primary30"
        data-testid="app-update-notice-reload"
        @click="reloadApp"
      >
        Atualizar agora
      </button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { watch } from 'vue'
import { useRoute } from 'vue-router'
import { mdiUpdate } from '@mdi/js'

import { useAppVersionCheck } from '@/hooks/useAppVersionCheck'

const route = useRoute()
const { updateAvailable, showUpdateNotice, dismiss, reloadApp, autoReloadForUpdate } =
  useAppVersionCheck()

// Posição: sempre no topo, centralizado. Embaixo ele disputava espaço com as barras fixas do
// dashboard no celular (semanas/zoom, seleção) e com a barra de gestos do Android.

// Telas sem operador (Modo TV) não têm quem clique: recarregam sozinhas (com trava anti-loop).
watch(
  updateAvailable,
  (available) => {
    if (available && route.meta.autoReloadOnUpdate) autoReloadForUpdate()
  },
  { immediate: true }
)
</script>
